// src/components/ProductCard/ProductCard.jsx


import { memo, Suspense } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import PriceGrid from '@/components/Price/PriceGrid';
import DynamicProductTitle from '@/components/Product/ProductCard/DynamicProductTitle';
import DynamicAddToCartButton from './DynamicAddToCartButton';
import { Typography } from '@mui/material';
import styles from '@/app/[lang]/shop/shop-category.module.scss'


const sizes = '(min-width: 1920px) 20vw, (min-width: 1440px) 25vw, (min-width: 960px) 33vw, (min-width: 480px) 50vw, 100vw';


const ProductCard = memo(

  function ProductCard({ product, lang='en', priority=false, category='carpets'}){

    const {
      titles,
      pricing,
      sku,
      mainImage,
      stock
    } = product;

    const base = `/${lang}/shop/${category}`;

    const hrefLink = sku ? `${base}/${titles.url}/${sku}` : `${base}/${titles.url}`;

    const imageSource = mainImage?.webp ?? mainImage?.png;

    return (
      <div className={styles.productCard}>
        <div aria-label={'Badges & Image container'}>
          { !stock && <Link href={'#'} className={'badge'} aria-label={'Badge'}>Sold</Link>}
          {/*<Link href={'#'} className={'badge'} aria-label={'Badge'}>50% Off</Link>*/}
          <Link href={hrefLink} tabIndex={-1} prefetch={false}>
            { imageSource?.url ?
              <Image
                src={imageSource?.url || null}
                alt={titles['SI'].altTag?.detailed}
                sizes={sizes}
                width={imageSource?.width}
                height={imageSource?.height}
                priority={priority}
                quality={50}
                // placeholder={'blur'}
                // blurDataURL={toBase64(shimmer(image.webpWidth, image.webpHeight))}
                // style={{
                //   // width: 'auto',
                //   // height: '500px',
                //   marginInline: 'auto'
                // }}
              /> :
              <Typography variant="body2" color="text.secondary" align="center" sx={{ width: '100%' }}>
                Image will be added later
              </Typography>
          }
          </Link>
        </div>

        <div aria-label={'Brief product description with options and shipping information'}>
          <Link href={hrefLink} prefetch={false}>
            <h2><DynamicProductTitle titles={titles}/></h2>
          </Link>

          {/*<p>Options</p>*/}

          {/*<p>Reviews</p>*/}

          <PriceGrid fontSize={'1.15em'} pricing={pricing} priceType="current" locale={lang} style={{marginBlockStart: '.75rem'}}/>

          {category === 'carpets' && <p>Free Shipping</p>}

          <p>Express Delivery</p>

          <Suspense fallback={<button className='pill-small'>...</button>}>
            <DynamicAddToCartButton productObj={product} lang={lang} category={category} />
          </Suspense>

        </div>
      </div>
    );
  }
);


export default ProductCard;
